export default __webpack_public_path__ + "static/media/59.2eaeae84.jpg";